module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "visual-item"
  }, [_vm._m(0), _vm._v(" "), _c('h4', [_vm._v("Schade melden")]), _vm._v(" "), _c('p', [_vm._v("U heeft schade die u bij ons wilt melden.")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary",
    attrs: {
      "href": _vm.ctx + '/' + _vm.schademeldenurl
    }
  }, [_vm._v("Schade melden")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hexagon-thick"
  }, [_c('p', {
    staticClass: "icon icon-schademelden clean"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-edaaf23a"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/frontend/components/schade/step1schademelden.vue
// module id = 68
// module chunks = 0